import { Scanner as ScannerComponent } from 'features/Scanner';
import { PunchupScanner } from 'features/PunchupPages/Scanner';
import { useAppSelector } from 'store/hooks';

const Scanner = (): JSX.Element => {
	const { isPunchup, greenZoneEnabled } = useAppSelector((state) => state.auth);
	if (isPunchup && greenZoneEnabled) return <PunchupScanner />;
	return <ScannerComponent />;
};

export default Scanner;
